/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AssistantsOverviewGetCompetences200ResponseInnerSubscriptionsInner } from './assistantsOverviewGetCompetences200ResponseInnerSubscriptionsInner';


export interface AssistantsOverviewGetCompetences200ResponseInner { 
    /**
     * 
     */
    descr: string;
    /**
     * 
     */
    type: AssistantsOverviewGetCompetences200ResponseInner.TypeEnum;
    /**
     * 
     */
    amount: number;
    /**
     * 
     */
    unit: string;
    /**
     * 
     */
    periodicity: string;
    /**
     * 
     */
    presenceRequired?: boolean;
    /**
     * 
     */
    periodicityData?: object;
    /**
     * 
     */
    subscriptions?: Array<AssistantsOverviewGetCompetences200ResponseInnerSubscriptionsInner>;
}
export namespace AssistantsOverviewGetCompetences200ResponseInner {
    export type TypeEnum = 'les' | 'link' | 'todo' | 'oefening' | 'examen';
    export const TypeEnum = {
        Les: 'les' as TypeEnum,
        Link: 'link' as TypeEnum,
        Todo: 'todo' as TypeEnum,
        Oefening: 'oefening' as TypeEnum,
        Examen: 'examen' as TypeEnum
    };
}


